const nameCache = new WeakMap();
function getElementName(selectorConfig, element) {
  if (!(element instanceof HTMLElement)) {
    let elementInstance = 'Unknown';

    // Types of elements according to LLM
    if (element instanceof Text) {
      elementInstance = 'Text';
    } else if (element instanceof DocumentFragment) {
      elementInstance = 'DocumentFragment';
    } else if (element instanceof Document) {
      elementInstance = 'Document';
    } else if (element instanceof Comment) {
      elementInstance = 'Comment';
    } else if (element instanceof ProcessingInstruction) {
      elementInstance = 'ProcessingInstruction';
    } else if (element instanceof Attr) {
      elementInstance = 'Attr';
    } else if (element instanceof CDATASection) {
      elementInstance = 'CDATASection';
    }
    if (element.parentElement && element.parentElement instanceof HTMLElement) {
      const parentElementSelector = getElementName(selectorConfig, element.parentElement);
      return `${parentElementSelector} > ${elementInstance}`;
    } else {
      return elementInstance;
    }
  }
  const cachedName = nameCache.get(element);
  if (cachedName) {
    return cachedName;
  }
  // Get the tag name of the element.
  const tagName = element.localName;
  const encodeValue = s => {
    if (typeof encodeURIComponent !== 'function') {
      return '';
    }
    try {
      return encodeURIComponent(s);
    } catch (e) {
      return 'malformed_value';
    }
  };

  // Helper function to construct attribute selectors.
  const getAttributeSelector = (attributeName, prefix = '') => {
    if (element && typeof element.getAttribute !== 'function') {
      return '';
    }
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) {
      return '';
    }
    const encondedAttrValue = encodeValue(attrValue);
    return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
  };

  // Construct the data-vc attribute selector if specified in the config.
  const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';

  // Construct the ID selector if specified in the config and the element has an ID.
  const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';

  // Construct the test ID selector if specified in the config.
  const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';

  // Construct the role selector if specified in the config.
  const role = selectorConfig.role ? getAttributeSelector('role') : '';
  const classNames = Array.from(element.classList).map(encodeValue).join('.');
  // Construct the class list selector if specified in the config.
  const classList = selectorConfig.className && classNames ? `.${classNames}` : '';

  // Combine primary attribute selectors (id, testId, role) into a single string.
  const primaryAttributes = [id, testId, role].filter(Boolean).join('');

  // Use dataVC if available, otherwise use the primary attributes.
  const attributes = dataVC || primaryAttributes;

  // If no attributes or class list, recursively get the parent's name.
  if (!attributes && !classList) {
    const parentName = element.parentElement ? getElementName(selectorConfig, element.parentElement) : 'unknown';
    return `${parentName} > ${tagName}`;
  }

  // Return the final constructed name: tagName + attributes or classList.
  const name = `${tagName}${attributes || classList}`;
  nameCache.set(element, name);
  return name;
}
export default getElementName;